import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

interface StarRatingProps {
  rating: number
  maxStars?: number
  size?: 'sm' | 'md' | 'lg'
  className?: string
  starClassName?: string
}

const sizeClasses = {
  sm: 'w-3 h-3',
  md: 'w-4 h-4',
  lg: 'w-5 h-5',
}

export function StarRating({
  rating,
  maxStars = 5,
  size = 'md',
  className,
  starClassName,
}: StarRatingProps) {
  return (
    <div className={cn('flex items-center gap-0.5', className)}>
      {[...Array(maxStars)].map((_, i) => {
        const fillPercent = Math.min(1, Math.max(0, rating - i))
        const isFull = fillPercent >= 1
        const isPartial = fillPercent > 0 && fillPercent < 1

        return (
          <div key={i} className={cn('relative', sizeClasses[size], starClassName)}>
            {/* Background star (empty) */}
            <Star className={cn('absolute inset-0 text-muted', sizeClasses[size])} />
            {/* Filled star with clip for partial support */}
            {(isFull || isPartial) && (
              <div
                className="absolute inset-0 overflow-hidden"
                style={{ width: `${fillPercent * 100}%` }}
              >
                <Star className={cn('text-yellow-400 fill-yellow-400', sizeClasses[size])} />
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
